import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "./about.scss";

const Image = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "12561.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img style={{ width: '350px' }} fluid={data.placeholderImage.childImageSharp.fluid} />
}


const AboutPage = () => (
  <Layout>
    <SEO title="About" />
    <div style={{ color: '#eeeeee'}}>
      <h4>Who are you ?</h4>
      <p>nc</p>
      <p>
        <a href="https://twitter.com/ncggro" target="_">Twitter </a> 
        <a href="https://github.com/NCanggoro" target="_">GitHub </a>
	<a href="https://gitlab.com/cloudcorezip" target="_">GitLab </a>
        <a href="mailto:ncanggoro@tutanota.com" target="_">Email </a>
      </p>
      <h4 className="faq-title">What do you do ?</h4>
      <p>Professional Typer</p>
      <h4 className="faq-title">What are your hobbies ?</h4>
      <p>Yes</p>
      <h4 className="faq-title">Don't care didn't ask</h4>
      <div style={{ maxWidth: `500px`}}>
        <Image />
      </div>
    </div>
  </Layout>
)

export default AboutPage
